<template>
  <v-card
    class="basicInfoFormCard secondaryBackground"
    :loading="updateOrLoadInProgress ? 'accent' : false"
    v-if="storyFound && authorized"
  >
    <v-form ref="basic-info-form">
      <v-container fluid class="pa-10">
        <v-row>
          <v-col cols="12" class="px-5">
            <StoryTitle
              v-model="localEditedStory.name"
              :disabled="updateOrLoadInProgress"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12" md="7" class="px-5">
            <Tagline
              v-model="localEditedStory.summary"
              :disabled="updateOrLoadInProgress"
            />
            <Description />
          </v-col>
          <v-col md="5" sm="12" class="px-5 right-column">
            <Genre v-model="genre" @genreObject="genreObject" />
            <AgeRating v-model="ageRating" @ageRatingObject="ageRatingObject" />
            <Tags v-model="tags" @tagsObject="tagsObject" />
            <Duration
              v-model="localEditedStory.duration"
              :disabled="updateOrLoadInProgress"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </v-card>
  <div v-else-if="storyFound && !authorized">
    <h1>{{ $t("storyHub.chapterList.notAuthorizedToEdit") }}</h1>
  </div>
  <div v-else-if="loading">
    <v-skeleton-loader class="mx-auto" type="list-item@6"></v-skeleton-loader>
  </div>
  <PageNotFound v-else />
</template>

<script>
import AgeRating from "./AgeRating";
import Description from "./Description";
import Duration from "./Duration";
import Genre from "./Genre";
import PageNotFound from "@/views/PageNotFound";
import StoryTitle from "./Title";
import Tagline from "./Tagline";
import Tags from "./Tags";
import storyBasicInfoForm from "@/mixins/storyBasicInfoForm";

export default {
  mixins: [storyBasicInfoForm],
  name: "BasicInfoForm",
  components: {
    AgeRating,
    Description,
    Duration,
    Genre,
    PageNotFound,
    StoryTitle,
    Tagline,
    Tags,
  },
  methods: {
    validate() {
      return this.$refs['basic-info-form'].validate();
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~vuetify/src/components/VStepper/_variables.scss";

::v-deep #descriptionTextArea {
  height: 202px;
  border-radius: $border-radius-root;
  overflow: hidden;
  padding: 12px;
  -webkit-mask-image: linear-gradient(180deg, #000 60%, transparent);
}
::v-deep .description-container {
  background-color: map-get($material-light, "background");
  border-radius: $border-radius-root;
}
::v-deep textarea {
  resize: none;
}

::v-deep .description-container-card {
  width: 100%;
}

::v-deep .v-text-field {
  margin-bottom: 0.75em;
}
</style>
